import React from 'react';
import { observer } from 'mobx-react';
import { Box } from '@mui/material';
import { useSubscriptionsStore } from '../../../store/models/subscriptions';
import useAppLocation from '../../../store/models/env/useAppLocation';
import LoadingAnimation from '../loadingAnimation';
import * as styles from './styles';

// syncRefresh (a just-closed sync widget's delayed refresh, or an
// unsubscribe/schedule change) blocks every page — a subscribe/unsubscribe
// action can be triggered from anywhere. loadProgress.subscriptions (the
// initial fetch on app boot) is only relevant on the Manage page, which
// already has its own skeleton for it — World has nothing to do with
// subscriptions loading and shouldn't be blocked by it.
function SubscriptionsLoadingOverlay() {
    const subscriptionsStore = useSubscriptionsStore();
    const { isManagePage } = useAppLocation();
    // Read only to subscribe this render to changes — the real value always
    // comes from the plain field below, per the observed-token convention.
    void subscriptionsStore.observed.loadProgress;

    const isLoading = subscriptionsStore.loadProgress.syncRefresh
        || (isManagePage && subscriptionsStore.loadProgress.subscriptions);
    if (!isLoading) return null;

    return (
        <Box sx={styles.overlay} role="alert" aria-busy="true" aria-label="Updating your subscriptions">
            <LoadingAnimation />
        </Box>
    );
}

const ObservedSubscriptionsLoadingOverlay = observer(SubscriptionsLoadingOverlay);
export default ObservedSubscriptionsLoadingOverlay;
